import { Link } from "react-router-dom";
import { SITE } from "@/config";

const LINKS = [
  { label: "Contact", to: "/contact" },
  { label: "Shipping", to: "/shipping" },
  { label: "Returns", to: "/returns" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

export const Footer = () => (
  <footer className="border-t border-line bg-sand" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-14 md:px-12 md:py-16">
      <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
        <Link
          to="/"
          className="font-display text-lg font-semibold tracking-[0.14em] text-ink"
          onClick={() => window.lenis?.scrollTo(0)}
        >
          {SITE.brand}
        </Link>
        <nav className="flex flex-wrap gap-x-7 gap-y-3">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-${l.label.toLowerCase()}`}
              className="text-sm text-graphite transition-colors duration-200 hover:text-ink"
              onClick={() => window.scrollTo(0, 0)}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-10 flex flex-col gap-2 border-t border-line pt-6 text-xs text-graphite/70 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} {SITE.companyName}. All rights reserved.</p>
        <p>Google is a trademark of Google LLC. Tap Review is not affiliated with Google.</p>
      </div>
    </div>
  </footer>
);
